'use client'

import React, { useEffect, useRef } from 'react'
import { usePathname } from 'next/navigation'

export const QuoteMedia: React.FC = () => {
    const scriptLoadedRef = useRef(false)
    const pathname = usePathname()

    useEffect(() => {
        if (!scriptLoadedRef.current) {
            const script = document.createElement('script')
            script.id = 'qmod'
            script.src = 'https://qmod.quotemedia.com/js/qmodLoader.js'
            script.setAttribute('data-qmod-wmid', '104750')
            script.setAttribute('qmod-env', 'app')
            script.setAttribute('qmod-version', '')
            script.async = true

            document.body.appendChild(script)

            return () => {
                document.body.removeChild(script)
            }
        }
    }, [pathname])

    return null
}
